import { render } from "./OffcanvasInfo.vue?vue&type=template&id=1f0b4f1c"
import script from "./OffcanvasInfo.vue?vue&type=script&lang=js"
export * from "./OffcanvasInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__